import React from 'react';
import { CtaBlock } from '../CtaButton';
import { MockupCrop } from '../MockupCrop';
import { volumesBand } from '../../data/images';

/** Section 12 — the price reveal and the checkout button. */
export function CheckoutSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-65" data-mp="1ts01poaa9w67">
      <div className="mx-auto max-w-3xl rounded-[28px] bg-brand-plum-dark px-6 py-12 text-center text-white shadow-[0_50px_100px_-50px_rgba(59,27,87,0.7)] sm:px-12 lg:py-16" data-id="element-66" data-mp="1oqkim1ro1zqg">
        <h2 id="offer-heading" className="mx-auto max-w-xl font-display text-[2.4rem] font-bold leading-[1.04] sm:text-[3.1rem]" data-id="element-67" data-mp="2hhubty37x6mr">
          How Much Is Your <em className="font-semibold italic text-brand-lilac" data-id="element-68" data-mp="28fl4fh38xtdl">Preparation Time</em> Worth?
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-white/75 sm:text-[16px]" data-id="element-69" data-mp="1144agz3hgwgt">
          Creating lesson structures, exercises, practice resources, assessments and classroom materials from
          scratch can consume hours of work. Makeup Instructor Ready puts an entire professional teaching
          system in one place.
        </p>

        <div className="mx-auto mt-10 rounded-[20px] bg-brand-ivory px-4 pb-6 pt-5" data-id="element-70" data-mp="2ri3jgwsquciv">
          <MockupCrop crop={volumesBand} alt="The six core volumes" data-id="element-71" data-mp="2rk6ank5mubp6" />
          <p className="mt-4 font-body text-[13px] font-bold uppercase tracking-[0.16em] text-brand-plum" data-id="element-72" data-mp="2vhlsau7aix5c">
            6 Core Volumes <span className="text-brand-gold" data-id="element-73" data-mp="2hq77chttolvn">+</span> 5 Extra Bonuses
          </p>
        </div>

        <p className="mt-10 font-body text-[12px] font-semibold uppercase tracking-[0.2em] text-brand-lilac" data-id="element-74" data-mp="2mkjvh568uldq">Only</p>
        <p className="mt-1 font-body font-bold leading-none tracking-[-0.01em]" data-id="element-75" data-mp="2csnvtpoien7e">
          <span className="text-[4rem] sm:text-[4.75rem]" data-id="element-76" data-mp="2cqkvabpqdbof">$27</span>
          <span className="ml-2 text-[1.25rem] text-white/65" data-id="element-77" data-mp="1yto7yk8tmcca">USD</span>
        </p>
        <p className="mt-3 font-body text-[12px] font-semibold uppercase tracking-[0.2em] text-white/75" data-id="element-78" data-mp="23r7l1gts8j2n">
          One-Time Payment
        </p>

        <div id="offer-cta" className="scroll-mt-24" data-id="element-79" data-mp="9dveawtntz0h">
          <CtaBlock label="Yes! Give Me Instant Access Now" action="checkout" tone="light" note="Instant Digital Access • No Subscription" className="mt-8" data-id="element-80" data-mp="4k97hla6gpcl" />
        </div>
      </div>
    </section>;
}